<template>
  <div class="forbidden-container">
    <div class="forbidden-card shadow-sm">
      <div class="icon-box">
        <i class="fas fa-user-shield"></i>
      </div>
      <h1>403 - ປະຕິເສດການເຂົ້າເຖິງ</h1>
      <p>ຂໍອະໄພ, ບັນຊີຂອງທ່ານບໍ່ມີສິດໃນການນຳໃຊ້ ຫຼື ເຂົ້າເບິ່ງຂໍ້ມູນໃນສ່ວນນີ້ຂອງລະບົບ.</p>
      <div class="info-note">
        <i class="fas fa-info-circle"></i>
        <span>ຫາກທ່ານຄິດວ່ານີ້ແມ່ນຂໍ້ຜິດພາດ, ກະລຸນາຕິດຕໍ່ຜູ້ດູແລລະບົບ (System Admin) ເພື່ອຂໍສິດທິເພີ່ມເຕີມ.</span>
      </div>
      <button class="btn-back" @click="$router.push({ name: 'Dashboard' })">
        <i class="fas fa-home"></i> ກັບຄືນໜ້າຫຼັກ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenPage'
}
</script>

<style scoped>
.forbidden-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  animation: fadeIn 0.4s ease;
}

.forbidden-card {
  background: white;
  padding: 50px 40px;
  border-radius: 20px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05);
}

.icon-box {
  width: 100px;
  height: 100px;
  background: #FDEEEE;
  color: #C0392B;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  margin: 0 auto 30px;
}

h1 {
  font-size: 24px;
  color: #0D1B2A;
  margin-bottom: 15px;
  font-weight: 800;
}

p {
  color: #4A5568;
  line-height: 1.6;
  margin-bottom: 25px;
  font-size: 15px;
}

.info-note {
  background: #f8fafc;
  padding: 15px;
  border-radius: 12px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 30px;
  border: 1px solid #E2E8F0;
}

.info-note i { color: #003F8A; margin-top: 3px; }
.info-note span { font-size: 13px; color: #8898AA; }

.btn-back {
  background: #003F8A;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: 0.3s;
}
.btn-back:hover { background: #002d62; transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(0, 63, 138, 0.2); }

@keyframes fadeIn { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>